// Generated from api/openapi/identity.yaml by make docs. Do not edit.
import { z } from "zod";

export const cascadePolicySchema = z.object({
  "cascade_order": z.array(z.enum(["totp", "recovery_code", "recovery_email"])),
  "default_order": z.array(z.enum(["totp", "recovery_code", "recovery_email"])),
  "final_order": z.array(z.enum(["totp", "recovery_code", "recovery_email"]))
});
